export default {
  isDebug: true,

  urlParams:null,
  status:null,
  locale:'en',
  orientation:'',
  model: null,
  UIModel: null,
  isPlaneStarted: false,
  state: '',
  isRealityCheckPopupPendingData: null,
  isQuickSpin: false,
  soundManager: null,
  StateSkipped: false,
  AutoPlaySettings: null
}